export function spy(a) {
    console.log(a);
    return a;
}
export function debug(message) {
    return function (a) {
        console.log(message, a);
        return a;
    };
}
